module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.item.orderType === 1) ? _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "padding": "10px 0"
    }
  }, [(_vm.item.iconTag) ? _c('img', {
    staticClass: "product-label",
    attrs: {
      "src": _vm.calTagName(_vm.item)
    }
  }) : _c('img', {
    staticClass: "product-label",
    attrs: {
      "src": _vm.emkt.getOrderMerchandiseLabel(_vm.item)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "block-address"
  }, [(_vm.item.iconUrl) ? _c('img', {
    staticClass: "largeIcon",
    attrs: {
      "src": _vm.item.iconUrl
    }
  }) : (_vm.item.merchandiseIcon) ? _c('img', {
    staticClass: "largeIcon",
    attrs: {
      "src": _vm.baseurl + _vm.item.merchandiseIcon
    }
  }) : (_vm.item.isStock === 0) ? _c('img', {
    staticClass: "largeIcon",
    attrs: {
      "src": _vm.baseurl + _vm.emkt.CUSTOMIZE_IMAGE
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "item-detail"
  }, [_c('span', {
    staticClass: "deep-text-color",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.item.name) + " ")]), _vm._v(" "), (_vm.showProductContractNo) ? _c('span', {
    staticClass: "research-font-color small-font"
  }, [_vm._v(_vm._s(_vm.item.contractNo))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "light-text-color small-font"
  }, [_vm._v(_vm._s(_vm.item.TLNo) + " " + _vm._s(_vm.item.tag1PUBID) + " " + _vm._s(_vm.item.eu_RID))]), _vm._v(" "), (_vm.item.tax) ? _c('span', {
    staticClass: "light-text-color small-font"
  }, [_vm._v(_vm._s(_vm.item.tax) + " "), (_vm.item.symbol) ? _c('span', [_vm._v(_vm._s(_vm.item.symbol))]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('span', {
    staticClass: "light-text-color"
  }, [_vm._v("X " + _vm._s(_vm.item.quantity))])]) : _c('div', {
    staticClass: "block-item",
    staticStyle: {
      "padding": "10px 0"
    }
  }, [_c('div', {
    staticClass: "block-address"
  }, [_c('img', {
    staticClass: "largeIcon",
    attrs: {
      "src": _vm.baseurl + 'service_product.png'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item-detail"
  }, [_c('span', {
    staticClass: "deep-text-color",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), (_vm.showProductContractNo) ? _c('span', {
    staticClass: "research-font-color small-font"
  }, [_vm._v(_vm._s(_vm.item.contractNo))]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6498ecec","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/emktcommon/orders/product/components/GcOrderProductBase.vue
// module id = 1662
// module chunks = 8